export default __webpack_public_path__ + "static/media/crew-03.b67d5f16.svg";